<template>  
    <form :key="fragment.uuid" class="mc-author-form e2e-form">
        <!-- forms hidden field to keep track which form was submitted -->
        <input  type="hidden"
                :name="fragment.uuid" 
                :value="fragment.uuid"/> 

        <!-- CONTENT  -->
        <div v-for="(entry,entryIndex) in fragment.entries" 
             :key="entryIndex">

                <!-- with label -->
                <div v-if="entry.label" class="form-group row">
                    <label class="col-sm-4 col-form-label col-form-label-sm">
                        {{entry.label}}
                    </label>
                    <div class="col-sm-8">
                        <div :fragment="entry.content"
                             :is="resolveFragmentComponentName(entry.content)">
                        </div>
                    </div>
                </div>

                <!-- without label -->
                <div v-else class="form-group row">
                    <div class="col-sm-12">
                        <div :fragment="entry.content"
                             :is="resolveFragmentComponentName(entry.content)">
                        </div>
                    </div>
                </div>
 
        </div> 

        <!-- DEFAULT SUBMIT BUTTONS --> 
        <div class="d-flex flex-row-reverse">
             <div   v-for="(submitFragment,i) in fragment.submitButtons"
                    :key="i"
                    :fragment="submitFragment"
                    :is="resolveFragmentComponentName(submitFragment)">
            </div>    
        </div> 

    </form> 
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver.js";

export default {
  name: "fragment-form",
  props: ["fragment"],
  methods: {
    resolveFragmentComponentName
  }
};
</script>
 

<style scoped>
form {
  margin-bottom: 15px;
}
</style>